import _find_coords from "./_find_coords";
//Componente para adicionar no mapa um caixa de pesquisa de lat/ln
/**
 * 
 * @param {Object} mapComponent instancia do componente de mapa. packs/components/map/map.js
 * @param {*} options 
 */
export default function LocationBox(mapComponent, options){
    let position = options.position || "topleft"
    let icon = options.icon || 'fas fa-crosshairs text-white'
    let title = options.title || ""
    let nearby_options = options.nearby_options || []
    let states = {
        valid_coord: false, 
        show: false
    }

    let container_element,find_location_button;

    this.generate = () =>{
        mapComponent.addLayerToMap(L.featureGroup(), 'location')
        generateFindLocationButton()
        generateContainer()
        $('body').append(container_element)
        initializeTippy()
        eventsHandler()
        setContainerPosition()
    }

    function setContainerPosition(){
        let positions = $(find_location_button).offset()
        if(position == 'topleft'){
            container_element.style = "left:"+(positions.left+50)+"px;top:"+(positions.top)+"px"
        } else {
            container_element.style = "left:"+(positions.left-320)+"px;top:"+(positions.top)+"px"
        }
    }

    function setInputValue(value){
        $('.find-location-box-container .find-box input').val(value)
    }

    function initializeTippy(){
        tippy('.find-location-box-container .find-box .fa-question-circle', {
            content: "Formatos suportados:<br> <span class='text-info'>Latitude/Longitude:</span> 99999.999,8888.88<br><span class='text-danger'>DMS (N/W):</span> DD MM SS DD MM SS",
            zIndex: 999999999999,
            theme:'material',
            allowHTML: true
        });
    }
    

    function generateContainer(){
        let element = document.createElement('div')
        
        element.classList.add('find-location-box-container')
        
        
        container_element = element
        $(container_element).html("<div class='find-box'><input type='text' value='' placeholder='lat,lng'></input><i title='Sua localização' class='fas fa-crosshairs text-danger mr-2 btn-location'></i><i class='fas fa-question-circle'></i></div><span class='error-span'>Coordenada inválida :(</span><span class='location-span'>Remover Localização</span>")
    }

    function generateFindLocationButton(){
        mapComponent.createDomElement('find-location-button', position, '<i title="'+title+'" class="'+icon+'"></i>', {click:btnFindLocationHandler})
        find_location_button = $('.find-location-button')[0]
    }

    function btnFindLocationHandler(){
        states.show = !states.show
        
        $('.find-location-box-container').toggleClass('open', states.show)
        
        if(!states.show){
            _find_coords.removeLocatedState()
        } else if(states.valid_coord){
            _find_coords.toLocatedState()
        }
        setContainerPosition()
        

    }

    function eventsHandler(){
        $(document).on('keypress', '.find-box input',function(e){
            _find_coords.toDefaultState()
            if(e.originalEvent.code == "Enter" || e.originalEvent.code == "NumpadEnter"){
                //pesquisar coordenada
                if(_find_coords.validateCoords(this.value.trim())){
                    //limpando qualquer outro marker no FeatureGroup location
                    mapComponent.clearLayer('location')
                    
                    let coords = _find_coords.convertToDecimalDegreesObject(this.value.trim())
                    //coordenada valida, convertendo para decimais (unica que o leaflet trabalha) e exibindo no mapa
                    mapComponent.zoomToCoord(coords, false, 13)
    
                    //adicionando o marker de localização no mapa através do FeatureGroup 'location'
                    mapComponent.addLayerToFeature('location', generateLocationMarker(coords.lat, coords.lng, 'Localização: '+coords.lat + ", " + coords.lng))
    
                    //exibindo o botão para remover o marcador de location
                    _find_coords.toLocatedState()

                    //marcando que tem um marcador no mapa
                    states.valid_coord = true
                } else {
                    //coordenada incorreta, alterando o status do card para erro
                    _find_coords.toIncorrectState()
                }
            }
        })

        $(document).on('click', '.find-box .btn-location', function(){
            //limpando qualquer outro marker no FeatureGroup location
            mapComponent.clearLayer('location')
            
            _find_coords.toDefaultState()
    
            let success = (data)=>{
                //pegando coordenadas vindas do navegador
                let coords = data.coords
    
                //zoom para as coordenadas
                mapComponent.zoomToCoord({lat:coords.latitude, lng:coords.longitude}, false, 15)
    
                //adicionando o marker de localização no mapa através do FeatureGroup 'location'
                mapComponent.addLayerToFeature('location', generateLocationMarker(coords.latitude, coords.longitude, generateLocationMarkerContent(coords)))
    
                //exibindo o botão para remover o marcador de location
                _find_coords.toLocatedState()

                setInputValue(coords.latitude + ", " + coords.longitude)

                //marcando que tem marcador de localização no mapa
                states.valid_coord = true
            }
            let error = (data) =>{
                //erro ao capturar coordenadas
                $(document).trigger('location-box:your-location::error')
            }
            //pegando coordenadas do usuário pelo navegador
            navigator.geolocation.getCurrentPosition(success,error, {});
        })

        $(document).on('click', '.find-location-box-container .location-span', ()=>{
            //limpando layer location
            mapComponent.clearLayer('location')
    
            //escondendo botão 'remover localização'
            _find_coords.removeLocatedState()

            //marcando que não tem mais marcador de localização no mapa
            states.valid_coord = false
        })

        $(document).on('click', '.location-marker-nearby-markers', function(){
            // $(document).trigger('find-location-box:nearby-button::click', {id: this.dataset.id, lat: this.dataset.lat, lng: this.dataset.lng})
        })
    }

    function generateLocationMarkerContent(coords){
        let html = "<div><div>Localização</div><div>"
        if(nearby_options.length > 0){
            nearby_options.forEach(value=>{
                html += "<button class='location-marker-nearby-markers' data-lat="+coords.latitude+" data-lng="+coords.longitude+" data-id="+value+" type='button'>"+value+" km</button>"
            })
            
        } else {
            html += "</div></div>"
        }
        return html
    }

    function generateLocationMarker(lat, lng, title){
        let options = {
            borderColor: 'red',
            iconShape: 'circle-dot',
            iconSize: [18,18],
            borderWidth: 5
        };
        return L.marker(
            [lat, lng],
            {
                icon: L.BeautifyIcon.icon(options)
            }
        ).bindPopup(title);
    }

}